/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}, React.createElement("path", {
  d: "M3.964.338c-.222-.32-.444-.373-.832-.32-.722.107-1.388.16-1.776.587C-1.252 3.378.024 7.218 4.13 11.485c4.161 4.267 8.045 5.707 11.097 3.467.5-.373.61-1.013.721-1.707.111-.373.056-.586-.277-.853-.056 0-3.163-2.027-3.163-2.027-.777-.213-1.553.8-1.942 1.28-.444.48-.888.587-1.276.32-2.053-1.333-4.05-3.413-5.27-5.44-.278-.427-.167-.853.388-1.173.499-.427 1.609-1.067 1.442-1.814 0 0-1.83-3.147-1.886-3.2z",
  fillRule: "evenodd"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Phone";
Svg.element = element;
export default Svg;
